import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login.component';

const routes: Routes = [
  {path: '', component: LoginComponent}
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/login/login.routing.ts